// import React from "react";
// import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
// import styled from "@emotion/styled/macro";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemText from "@material-ui/core/ListItemText";
// import { makeStyles } from "@material-ui/core/styles";
// import AccountBalanceWalletOutlinedIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
// import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
// import LocalMallOutlinedIcon from "@material-ui/icons/LocalMallOutlined";
// import { Link } from "react-router-dom";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import StarBorderOutlinedIcon from "@material-ui/icons/StarBorderOutlined";
// import SupervisorAccountOutlinedIcon from "@material-ui/icons/SupervisorAccountOutlined";
// import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     maxWidth: "1500px",
//     margin: "10px auto",
//     width: "90%",
//   },
//   list: {
//     paddingTop: 0,
//   },
//   listItem: {
//     borderBottom: "1px dashed #e5dddd",
//     padding: "5px",
//     cursor: "pointer",
//     "&:hover": {
//       background: "rgba(14, 118, 186, .08)",
//     },
//   },
//   primary: {
//     fontSize: "0.875rem",
//     color: "#0e76ba",
//   },
//   secondary: {
//     fontSize: "0.85em",
//   },
//   section: {
//     maxWidth: "350px",
//     marginBottom: "35px",
//   },
//   h6: {
//     // borderBottom: '2px solid #027a5f',
//     fontSize: "1.15em",
//     color: "#4e4848",
//   },
//   icon: {
//     // color: '#464545',
//     width: ".8em",
//   },
//   span: {
//     marginRight: "2px",
//   },
//   listItemIcon: {
//     minWidth: "26px",
//   },
//   listIcon: {
//     width: ".75em",
//   },
//   nested: {
//     paddingLeft: theme.spacing(4),
//   },
// }));

// const ReportsContainer = styled.div({
//   padding: "40px 80px",
// });

// const PurchaseAndSalesReports = () => {
//   const classes = useStyles();
//   const user = JSON.parse(sessionStorage.getItem("user"));
//   const singleUser = !user ? {} : user;
//   const permissions = !singleUser.permission ? {} : singleUser.permission;
//   // pick only the report-related permissions
//   const stock_report = permissions.stock_report || {};
//   const sales_report = permissions.sales_report || {};
//   const sales_report_medicine_wise = permissions.sales_report_medicine_wise || {};
//   const purchase_report = permissions.purchase_report || {};
//   const profit_loss = permissions.profit_loss || {};
//   const todays_report = permissions.todays_report || {};
//   const journals = permissions.journals || {};
//   const expenses = permissions.expenses || {};
//   const trial_balance = permissions.trial_balance || {};
//   const balance_sheet = permissions.balance_sheet || {};
//   const customer_balances= permissions.customer_balances || {};
//   const expired_products= permissions.expired_products || {};
//   const product_history= permissions.product_history || {};
//   const stock_summary= permissions.stock_summary || {};
//   const aging_report= permissions.aging_report || {};
//   const product_trends= permissions.product_trends || {};
//   const bills= permissions.bills || {};









//   const list = [
//     {
//       id: 1,
//       title: "Inventory",
//       icon: <LocalMallOutlinedIcon classes={{ root: classes.icon }} />,
//       children: [
//         { name: "Product Trends", url: "/product_trends", id: "401" },
//         { name: "Expired Products", url: "/expired_drugs", id: "404" },
//         { name: "Stock Report", url: "/stockreport", id: "403" },
//         { name: "Aging Report", url: "/aging_report", id: "405" },
//         { name: "Out of Stock", url: "/out_of_stock", id: "405" },
//         { name: "Stock Summary", url: "/stocksummary", id: "201" },
//         { name: "Product History Report", url: "/product_history", id: "402" },
//       ],
//     },
//     {
//       id: 2,
//       title: "Financial Reports",
//       icon: <ShoppingCartOutlinedIcon classes={{ root: classes.icon }} />,
//       children: [
//         { name: "Sales Report", url: "/sales_report", id: "201" },
//         {
//           name: "Sales Report(Medicine Wise) ",
//           url: "/sales_report_medicine_wise",
//           id: "202",
//         },
//         { name: "Purchase Report", url: "/purchase_report", id: "401" },
//       ],
//     },

//     {
//       id: 3,
//       title: 'Accounting Reports',
//       icon: <AccountBalanceWalletOutlinedIcon classes={{ root: classes.icon }} />,
//       children: [
//         { name: 'Profit & Loss Statement', url: '/report/profit_loss_statement', id: '201' },
//         { name: 'Balance Sheet', url: '/report/balancesheet', id: '201' },
//         { name: 'Trial Balance', url: '/report/trialbalance', id: '201' },
//         // {name: 'Customer Receivables', url: '/accounting/debtors', id: '201'},
//         // {name: 'Accounts Payable', url: '/creditors', id: '201'},
//       ]
//     },
//     {
//       id: 4,
//       title: "Payables",
//       icon: <ReceiptOutlinedIcon classes={{ root: classes.icon }} />,
//       children: [
//         { name: "Bills", url: "/creditors/report", id: "201" },
//         // {name: 'Payables Summary', url: '/creditorssummary', id: '201'},
//         // {name: 'Payments Made', url: '/creditorssummary', id: '201'},
//       ],
//     },

//     {
//       id: 5,
//       title: "Receivables",
//       icon: <SupervisorAccountOutlinedIcon classes={{ root: classes.icon }} />,
//       children: [
//         {
//           name: "Customer Balances",
//           url: "/accounting/debtors/report",
//           id: "201",
//         },
//         // {name: 'Receivables Summary', url: '/debtorssummary', id: '201'},
//       ],
//     },
//   ];

//   return (
//     <div className="journals">
//       <ReusableDashboardHeader
//         component="Reports"
//         heading="Reports"
//         subHeading="Reports"
//         link="/allreports"
//       />
//       <ReportsContainer>
//         <div className="row">
//           {list.map((item) => (
//             <div key={item.id} className="col-lg-4">
//               <div className={classes.section}>
//                 <h6 className={classes.h6}>
//                   <span className={classes.span}>{item.icon}</span>
//                   {item.title}
//                 </h6>
//                 {item.children.map((it) => (
//                   <List classes={{ root: classes.list }} key={it.id}>
//                     <Link to={it.url} style={{ textDecoration: "none" }}>
//                       <ListItem classes={{ root: classes.listItem }}>
//                         <ListItemIcon classes={{ root: classes.listItemIcon }}>
//                           <StarBorderOutlinedIcon
//                             classes={{ root: classes.listIcon }}
//                           />
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={it.name}
//                           classes={{ primary: classes.primary }}
//                         />
//                       </ListItem>
//                     </Link>
//                     {Array.isArray(it.children)
//                       ? it.children.map((child) => (
//                         <List key={child.id} component="div" disablePadding>
//                           <Link
//                             to={child.url}
//                             style={{ textDecoration: "none" }}
//                           >
//                             <ListItem
//                               button
//                               classes={{ root: classes.listItem }}
//                               className={classes.nested}
//                             >
//                               <ListItemIcon
//                                 classes={{ root: classes.listItemIcon }}
//                               >
//                                 <StarBorderOutlinedIcon
//                                   classes={{ root: classes.listIcon }}
//                                 />
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary={child.name}
//                                 classes={{ primary: classes.primary }}
//                               />
//                             </ListItem>
//                           </Link>
//                         </List>
//                       ))
//                       : null}
//                   </List>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </ReportsContainer>
//     </div>
//   );
// };
// export default PurchaseAndSalesReports;



import React from "react";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import styled from "@emotion/styled/macro";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import AccountBalanceWalletOutlinedIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import LocalMallOutlinedIcon from "@material-ui/icons/LocalMallOutlined";
import { Link } from "react-router-dom";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import StarBorderOutlinedIcon from "@material-ui/icons/StarBorderOutlined";
import SupervisorAccountOutlinedIcon from "@material-ui/icons/SupervisorAccountOutlined";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";

const useStyles = makeStyles((theme) => ({
  section: {
    maxWidth: "350px",
    marginBottom: "35px",
  },
  h6: {
    fontSize: "1.15em",
    color: "#4e4848",
  },
  icon: {
    width: ".8em",
  },
  span: {
    marginRight: "2px",
  },
  list: { paddingTop: 0 },
  listItem: {
    borderBottom: "1px dashed #e5dddd",
    padding: "5px",
    cursor: "pointer",
    "&:hover": {
      background: "rgba(14, 118, 186, .08)",
    },
  },
  primary: { fontSize: "0.875rem", color: "#0e76ba" },
  listItemIcon: { minWidth: "26px" },
  listIcon: { width: ".75em" },
  nested: { paddingLeft: theme.spacing(4) },
}));

const ReportsContainer = styled.div({
  padding: "40px 80px",
});

const PurchaseAndSalesReports = () => {
  const classes = useStyles();

  // --- permissions setup ---
  const user = JSON.parse(sessionStorage.getItem("user"));
  const singleUser = !user ? {} : user;
  const permissions = !singleUser.permission ? {} : singleUser.permission;

  // map permission keys to report names
  const permissionMap = {
    "Product Trends": permissions.product_trends,
    "Expired Products": permissions.expired_products,
    "Stock Report": permissions.stock_report,
    "Aging Report": permissions.aging_report,
    "Out of Stock": permissions.stock_report, // you might need a specific key
    "Inventory Loss Adjustment Report": permissions.stock_report, // you might need a specific key
    "Stock Movement Summary": permissions.stock_summary,
    "Product History Report": permissions.product_history,
    "Sales Report": permissions.sales_report,
    "Sales Report(Medicine Wise)": permissions.sales_report_medicine_wise,
    "Purchase Report": permissions.purchase_report,
    "Profit & Loss Statement": permissions.profit_loss,
    "Balance Sheet": permissions.balance_sheet,
    "Trial Balance": permissions.trial_balance,
    "Bills": permissions.bills,
    "Customer Balances": permissions.customer_balances,
    "General Profit & Loss Report": permissions.profit_loss,
    "Expense Report": permissions.balance_sheet,
    "Soon To Expire ": permissions.aging_report,
    "Performance Report ": permissions.stock_report,
    "Damaged Goods Report": permissions.stock_report,
    "Customer Performance": permissions.stock_report,
    "Cash Flow": permissions.balance_sheet,
    "Detailed Cash Flow": permissions.balance_sheet,


  };

  const list = [
    {
      id: 1,
      title: "Inventory",
      icon: <LocalMallOutlinedIcon classes={{ root: classes.icon }} />,
      children: [
        { name: "Product Trends", url: "/product_trends", id: "401" },
        { name: "Expired Products", url: "/expired_drugs", id: "404" },
        { name: "Stock Report", url: "/stockreport", id: "403" },
        { name: "Aging Report", url: "/aging_report", id: "405" },
        { name: "Out of Stock", url: "/out_of_stock", id: "406" },
        { name: "Stock Movement Summary", url: "/stocksummary", id: "201" },
        { name: "Product History Report", url: "/product_history", id: "402" },
        { name: "Damaged Goods Report", url: "/damaged_goods", id: "402" },
        { name: "Inventory Loss Adjustment Report", url: "/new_stock_adjustment_report", id: "409" },

        // { name: "Product History Report", url: "/product_history", id: "402" },
        { name: "Soon To Expire ", url: "/soon_to_expire", id: "407" },
        // { name: "Soon To Expire ", url: "/soon_to_expire", id: "407" },
      ],
    },
    {
      id: 2,
      title: "Financial Reports",
      icon: <ShoppingCartOutlinedIcon classes={{ root: classes.icon }} />,
      children: [
        { name: "Sales Report", url: "/sales_report", id: "201" },
        {
          name: "Sales Report(Medicine Wise)",
          url: "/sales_report_medicine_wise",
          id: "202",
        },
        {
          name: "General Profit & Loss Report",
          url: "/general-profit-loss",   // ← THIS MUST MATCH YOUR ROUTE
          id: "203",
        },
        {
          name: "Expense Report",
          url: "/expense-report",   // ← THIS MUST MATCH YOUR ROUTE
          id: "203",
        },
        { name: "Purchase Report", url: "/purchase_report", id: "401" },
        { name: "Performance Report ", url: "/performance_report", id: "408" },
        { name: "Customer Performance", url: "/customer_performance", id: "402" },


      ],
    },
    {
      id: 3,
      title: "Accounting Reports",
      icon: <AccountBalanceWalletOutlinedIcon classes={{ root: classes.icon }} />,
      children: [
        {
          name: "Profit & Loss Statement",
          url: "/report/profit_loss_statement",
          id: "301",
        },
        { name: "Balance Sheet", url: "/report/balancesheet", id: "302" },
        { name: "Trial Balance", url: "/report/trialbalance", id: "303" },
        { name: "Cash Flow", url: "/accounting/cashflow", id: "303" },
        { name: "Detailed Cash Flow", url: "/accounting/cashflow_details", id: "303" },


      ],
    },
    {
      id: 4,
      title: "Payables",
      icon: <ReceiptOutlinedIcon classes={{ root: classes.icon }} />,
      children: [{ name: "Bills", url: "/creditors/report", id: "401" }],
    },
    {
      id: 5,
      title: "Receivables",
      icon: <SupervisorAccountOutlinedIcon classes={{ root: classes.icon }} />,
      children: [
        { name: "Customer Balances", url: "/accounting/debtors/report", id: "501" },
      ],
    },
  ];

  // --- filter reports based on permissions ---
  const filteredList = list.map((section) => ({
    ...section,
    children: section.children.filter(
      (child) => permissionMap[child.name] && permissionMap[child.name].read
    ),
  }));

  return (
    <div className="journals">
      <ReusableDashboardHeader
        component="Reports"
        heading="Reports"
        subHeading="Reports"
        link="/allreports"
      />
      <ReportsContainer>
        <div className="row">
          {filteredList.map(
            (item) =>
              item.children.length > 0 && (
                <div key={item.id} className="col-lg-4">
                  <div className={classes.section}>
                    <h6 className={classes.h6}>
                      <span className={classes.span}>{item.icon}</span>
                      {item.title}
                    </h6>
                    {item.children.map((it) => (
                      <List classes={{ root: classes.list }} key={it.id}>
                        <Link to={it.url} style={{ textDecoration: "none" }}>
                          <ListItem classes={{ root: classes.listItem }}>
                            <ListItemIcon classes={{ root: classes.listItemIcon }}>
                              <StarBorderOutlinedIcon
                                classes={{ root: classes.listIcon }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary={it.name}
                              classes={{ primary: classes.primary }}
                            />
                          </ListItem>
                        </Link>
                      </List>
                    ))}
                  </div>
                </div>
              )
          )}
        </div>
      </ReportsContainer>
    </div>
  );
};

export default PurchaseAndSalesReports;
